import {createSelector} from 'reselect';

export const getUser = state => state.user;

export const getLikedImageIds = createSelector(getUser, state => state.likedImageIds);

export const getImagesWithPendingLikeStatusChange = createSelector(getUser, state => state.imagesWithPendingLikeStatusChange);
